import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import frLocale from "@fullcalendar/core/locales/fr";
import timeGridPlugin from "@fullcalendar/timegrid";
import multiMonthYear from "@fullcalendar/multimonth";
import "./style.scss";
import interactionPlugin from "@fullcalendar/interaction"; // plugin pour les interactions comme la sélection
import { CustomContentGenerator, EventContentArg } from "@fullcalendar/core";
import { useRef } from "react";

const viewTypes = [
  "multiMonthYear",
  "dayGridMonth",
  "timeGridWeek",
  "timeGridDay",
] as const;

type ViewType = (typeof viewTypes)[number];

type PropsType = {
  onClick: (e: any) => void;
  viewType?: ViewType[];
  events?: any[];
  renderContent?: CustomContentGenerator<EventContentArg>;
  onChangeYear?: (year: any) => void;
};

export const CustomCalendar = ({
  onClick,
  viewType = ["multiMonthYear", "dayGridMonth"],
  events,
  renderContent,
  onChangeYear,
}: PropsType) => {
  const prevYearRef = useRef<number | null>(null);

  const handleDatesSet = (arg: any) => {
    const currentYear = arg.view.currentStart.getFullYear();

    if (prevYearRef.current !== currentYear) {
      prevYearRef.current = currentYear;
      if (onChangeYear) {
        onChangeYear(currentYear);
      }
    }
  };
  return (
    <div className="custom-cal">
      <FullCalendar
        locale={frLocale}
        headerToolbar={{
          left: "prev,next today",
          center: "title",
          right: viewType.toString(),
        }}
        plugins={[
          multiMonthYear,
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
        ]}
        events={events}
        eventContent={renderContent}
        initialView="dayGridMonth"
        dayMaxEventRows={true}
        selectable={true}
        datesSet={handleDatesSet}
        select={(info) => {
          const selectedDate = info.start;

          const eventsOnDate = (events || []).filter((event) => {
            const eventDate = new Date(event.start); // make sure it's a Date object
            return (
              eventDate.getFullYear() === selectedDate.getFullYear() &&
              eventDate.getMonth() === selectedDate.getMonth() &&
              eventDate.getDate() === selectedDate.getDate()
            );
          });

          onClick({ date: info?.startStr, event: eventsOnDate?.[0] });
        }}
        views={{
          timeGrid: {
            eventLimit: 6,
          },
          timeGridWeek: {
            dayMaxEventRows: 4,
            eventMaxStack: 1,
          },
          timeGridDay: {
            dayMaxEventRows: 4,
            eventMaxStack: 1,
          },
          dayGrid: {
            dayMaxEventRows: 4,
            eventMaxStack: 1,
          },
          week: {
            dayMaxEventRows: 4,
            eventMaxStack: 1,
            slotMinTime: "06:00",
            slotMaxTime: "24:00",
            // height:'100%'
          },
          day: {
            dayMaxEventRows: 4,
            eventMaxStack: 1,
            slotMinTime: "06:00",
            slotMaxTime: "24:00",
            // height:'100%'
          },
        }}
      />
    </div>
  );
};
